export default "__VITE_ASSET__EOoyaJYC__"